// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.loading-indicator[data-v-99357410] {\n  color: #ffc107;\n  font-size: 0.9em;\n  margin-left: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
